import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Typography, Button } from "@mui/material";
import DailyThroughputChart from "../components/DailyThroughputChart";
import DateSelector from "../components/DateSelector";
import DailyViewLayout from "../components/DailyViewLayout";
import { fetchAllWorkcells } from "../api";
import { useTranslation } from "react-i18next";
import { formatLocalDate } from "../utils/localDateTime";

const DailyPlannings = () => {
  const { date, workcell_id } = useParams();
  const navigate = useNavigate();
  const [workcellName, setWorkcellName] = useState("");
  const { t } = useTranslation();

  // Default to today if no date is provided
  const selectedDate = date || formatLocalDate(new Date());

  // Fetch workcell name
  useEffect(() => {
    const getWorkcellName = async () => {
      try {
        const workcells = await fetchAllWorkcells();
        const workcell = workcells.find(w => w.workcell_id === parseInt(workcell_id));
        if (workcell) {
          setWorkcellName(workcell.workcell_name);
        }
      } catch (error) {
        console.error("Error fetching workcell name:", error);
      }
    };

    getWorkcellName();
  }, [workcell_id]);

  // Navigate only if the URL doesn't match
  useEffect(() => {
    if (!date || date !== selectedDate) {
      navigate(`/chart/daily/plannings/${selectedDate}/${workcell_id}`, { replace: true });
    }
  }, [date, selectedDate, workcell_id, navigate]);

  const handleShowTotalDailyThroughput = () => {
    navigate(`/chart/daily/plannings/${selectedDate}`);
  };

  return (
    <DailyViewLayout date={selectedDate}>
      <DateSelector date={selectedDate} setDate={(newDate) => navigate(`/chart/daily/plannings/${newDate}/${workcell_id}`)} />
      <Typography variant="h6">
        {t("daily.plannings.workcellPage.title", { name: workcellName })}
      </Typography>
      <DailyThroughputChart date={selectedDate} workcellId={workcell_id} />
      <Button variant="contained" onClick={handleShowTotalDailyThroughput}>
        {t("daily.plannings.workcellPage.showTotal")}
      </Button>
    </DailyViewLayout>
  );
};

export default DailyPlannings;
